import { stagesList } from '@/constants/contact-stages';
import { useMixpanel } from '@/hooks/use-mixpanel';
import { Avatar, Box, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { KText } from 'ui-library/components';
import { HighlightedText } from '../components/HighlightedText';

export const ContactSearchItem = ({
  contact,
  showBorderBottom,
  searchTerm,
}) => {
  const { track } = useMixpanel();
  return (
    <Link
      to={`/contacts/${contact.id}`}
      onClick={() => {
        track({
          event: 'global-serach-item-click',
          prop: { type: 'contact' },
        });
      }}
    >
      <Flex
        minH="40px"
        py="18px"
        gap="20px"
        borderBottom={`${showBorderBottom ? '1px solid #F3F3F3' : ''}`}
        cursor="pointer"
        _hover={{ backgroundColor: '#f6f7f7' }}
        px="8px"
        mx="8px"
        className="universal--search--item"
        borderRadius="8px"
      >
        <Avatar
          w="36px"
          h="36px"
          className="avatar-md"
          name={`${contact?.first_name} ${
            contact.last_name ? contact.last_name : ''
          }`}
          src={contact?.image_url}
        />
        <Flex flexDirection="column" gap="4px">
          <Flex gap="10px" alignItems="center">
            <KText
              size="sm"
              lineHeight="18px"
              letterSpacing="0.16px"
              textTransform="capitalize"
            >
              <HighlightedText
                text={`${contact?.first_name} ${
                  contact.last_name ? contact.last_name : ''
                }`}
                highlight={searchTerm}
              />
            </KText>
            {contact?.email && (
              <>
                <Box
                  w="5px"
                  h="5px"
                  borderRadius="full"
                  backgroundColor="secondary-700"
                />
                <KText size="sm">
                  <HighlightedText
                    text={contact?.email}
                    highlight={searchTerm}
                  />
                </KText>
              </>
            )}
          </Flex>
          <Flex gap="10px" alignItems="center">
            {contact?.position && (
              <>
                <KText color="secondary-700" textTransform="capitalize">
                  {contact?.position}
                </KText>
              </>
            )}
            {contact?.company_name && (
              <>
                <Box
                  w="5px"
                  h="5px"
                  borderRadius="full"
                  backgroundColor="secondary-700"
                />
                <KText color="secondary-700" textTransform="capitalize">
                  {contact?.company_name}
                </KText>
              </>
            )}

            {contact?.stage && (
              <>
                <Box
                  w="5px"
                  h="5px"
                  borderRadius="full"
                  backgroundColor="secondary-700"
                />
                <KText color="secondary-700" textTransform="capitalize">
                  {stagesList[contact?.stage]?.label}
                </KText>
              </>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Link>
  );
};
